import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M34.01 12a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h1.323a1 1 0 0 0 .989-.855q.701-4.766.697-11.074-.005-6.333-.72-11.216a1 1 0 0 0-.99-.855zm4.268.565q.737 5.035.74 11.505.006 6.445-.717 11.366A3 3 0 0 1 35.333 38H34.01a3 3 0 0 1-3-3V13a3 3 0 0 1 3-3h1.3a3 3 0 0 1 2.968 2.565m-24.154-1.053 15.232 9.52a3.5 3.5 0 0 1-.002 5.938l-15.252 9.519a3 3 0 0 1-4.57-2.212Q8.997 29.472 9 24.063q.003-5.439.553-10.342a3 3 0 0 1 4.571-2.21m-1.479 1.55a1 1 0 0 1 .42.146l15.23 9.52a1.5 1.5 0 0 1 0 2.545l-15.252 9.52a1 1 0 0 1-1.523-.738q-.523-4.69-.52-9.99.004-5.33.54-10.12a1 1 0 0 1 1.106-.883",
      clipRule: "evenodd"
    }
  )
);
var SvgSkipNextOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SkipNextOutlined_default = SvgSkipNextOutlined;

export { SkipNextOutlined_default as default };
